import {
  Action,
  OrderBulkRequest,
  OrderResponse,
} from "models/order-management/models";

export default class Utils {
  static truncateAndAddEllipsis(stringLimit: number, str: string) {
    let tempStr = str;
    if (str.length > stringLimit) {
      tempStr = tempStr.substr(0, stringLimit - 4) + " ...";
    }
    return tempStr;
  }

  static createTrackOrdersPayload(
    values: Partial<OrderResponse>[],
    actionType: Action.ActionTypeEnum,
    timezone: string,
    displayName: string
  ): OrderBulkRequest {
    if (values && values.length > 0) {
      return values.map((order) => {
        return {
          action: {
            actionType,
            displayName,
            timezone,
          },
          orderId: order.orderId,
          order: {
            medicationId: order.medicationId,
          },
        };
      });
    }
    return [];
  }

  static transformAddress(address) {
    const addressParts = Object.keys(address)
      .filter((key) =>
        ["address1", "address2", "city", "state", "zip"].includes(
          key.toLowerCase()
        )
      )
      .map((key) => {
        if (address[key]) {
          return address[key].trim();
        }
      })
      .filter((part) => part && part !== "-");
    return addressParts.length > 0 ? addressParts.join(", ") : "";
  }

  static formatPhoneMobileOrFaxNumber(contactNumber: string): string {
    const cleaned = ("" + contactNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return contactNumber;
  }

  static getFileName(fileName: string): string {
    const lastDotIndex = fileName.lastIndexOf(".");
    return lastDotIndex === -1 ? fileName : fileName.substring(0, lastDotIndex);
  }
}



// WEBPACK FOOTER //
// ./src/utils/Utilities.ts